// extracted by mini-css-extract-plugin
export var assigneeBadge = "_kj-0";
export var assigneeDetails = "_kj-1";
export var assigneeInfo = "_kj-2";
export var dropdownContainer = "_kj-4";
export var dropdownImage = "_kj-5";
export var editAssigneeInfo = "_kj-3";
export var editAssigneeModalContainer = "_kj-6";
export var hidden = "_kj-8";
export var input = "_kj-7";